import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, onUnmounted } from 'vue'

  import KetchUpButton from '@/components/common/KetchUpButton.vue'

  import useI18n from '@/composables/useI18n'
  import { UserModule } from '@/store/modules/user'
  import useCommonMixin from '@/composables/useCommonMixin'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Logout',
  setup(__props) {

  const { translateString } = useI18n()
  const { hasValidUser } = useCommonMixin()

  const countdown = ref(10)

  let countdownInterval: NodeJS.Timeout | null = null

  const handleLogout = async () => {
    await UserModule.logout()
    window.location.href = '/login'
  }

  const startCountdown = async () => {
    countdownInterval = setInterval(() => {
      countdown.value--

      if (countdown.value <= 0) {
        clearInterval(countdownInterval!)
        handleLogout()
      }
    }, 1000)
  }

  onMounted(() => {
    if (hasValidUser.value) {
      startCountdown()
    } else {
      handleLogout()
    }
  })

  onUnmounted(() => {
    if (countdownInterval) {
      clearInterval(countdownInterval)
    }
  })

return { __sfc: true,translateString, hasValidUser, countdown, countdownInterval, handleLogout, startCountdown, ref, onMounted, onUnmounted, KetchUpButton, useI18n, UserModule, useCommonMixin }
}

})